import {EditOutlined, MoreOutlined} from "@ant-design/icons";
import {Button, Divider, Dropdown, Modal, notification} from "antd";
import React, {useState} from "react";
import {CategoryDTO} from "../../../types/category/CategoryDTO";
import {useUpdateCategoryMutation} from "../../../store/api/CategoryApi";
import {CategoryCreateDTO} from "../../../types/category/CategoryCreateDTO";
import CategoryCreateForm from "../create/CategoryCreateForm";

interface CategoryActionButtonProps {
    category: CategoryDTO
}

const items = [
    {
        key: "update",
        label: <><EditOutlined/> Изменить</>
    }
]

const CategoryActionButton: React.FC<CategoryActionButtonProps> = ({category}) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [updateCategory] = useUpdateCategoryMutation()

    const onClickHandler = async (key: string) => {
        if (key === 'update') {
            setVisible(true)
        }
    }

    const onCloseHandler = () => setVisible(false)

    const onFinishHandler = async (id: number, dto: CategoryCreateDTO) => {
        setLoading(true)
        await updateCategory({id, dto})
            .then(() =>
                notification.success({
                    message: 'Категория успешно изменена!',
                    duration: 5
                })
            )
            .catch(error =>
                notification.error({
                    message: `Ошибка ${error.status}`,
                    description: error.data.message,
                    duration: 5
                })
            )
        setVisible(false)
        setLoading(false)
    }

    return (
        <>
            <Dropdown menu={{items, onClick: item => onClickHandler(item.key)}}>
                <Button>
                    <MoreOutlined/>
                </Button>
            </Dropdown>
            <Modal
                title="Изменить категорию"
                open={visible}
                onCancel={onCloseHandler}
                okText="Изменить"
                destroyOnClose
                okButtonProps={{
                    disabled: loading,
                    form: "category-create-form",
                    htmlType: "submit"
                }}
            >
                <Divider/>
                <CategoryCreateForm category={category} onFinish={(data) => onFinishHandler(category.id, data)}/>
            </Modal>
        </>
    )
}

export default CategoryActionButton;